<!--
  --
  -- 概要カード
  --
  -->
<template>
  <v-card>
    <v-card-title>ご予約内容</v-card-title>

    <v-card-text>
      <div class="mb-4">
        <div class="text-caption mb-1">予約先</div>
        <div class="text--primary font-weight-bold">{{station.name}}</div>
        <div v-show="station.addressShow">
          <a :href="station.map" target="_blank">{{station.address}}</a>
        </div>
      </div>

      <div>
        <div class="text-caption mb-2">ご利用日程</div>
        <div class="d-flex align-center">
          <c-time-sheet :color="timeColor" class="flex-grow-1" :time="schedule.begin"/>
          <v-icon class="flex-shrink-0">arrow_right</v-icon>
          <c-time-sheet :color="timeColor" class="flex-grow-1" :time="schedule.end"/>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import CTimeSheet from '@/components/CTimeSheet'

export default {
  name: 'CSummaryCard',
  components: {
    CTimeSheet
  },

  computed: {
    station () {
      const station = this.getters['book/station']
      // 明伸興産kintoは住所を表示しない
      if (station.shopID === 240) {
        station.addressShow = false
      } else {
        station.addressShow = true
      }
      return station
    },

    schedule () {
      return this.getters['book/schedule']
    },

    timeColor () {
      return this.$vuetify.theme.isDark ? 'rgba(0,0,0,.5)' : 'rgba(0,0,0,.05)'
    }
  }
}
</script>
